import * as React from 'react';
import { isSessionDeleted, userSession } from 'state/session';
import DeletedSessionRoute from './DeletedSessionRoute';
import PrescheduledRoute from './PrescheduledRoute';

/**
 * Chooser for `:sessionId/scheduled`: renders the deleted-session dialog if the
 * loaded session has the schedule-delete fingerprint, otherwise the standard
 * pre-scheduled "Session Scheduled" dialog.
 *
 * Uses `useState()` (reactive) — not `get()` — so a state change after mount
 * re-evaluates the branch instead of locking in a stale render.
 */
export default function ScheduledOrDeletedRoute() {
  const session = userSession().useState();
  return isSessionDeleted(session) ? <DeletedSessionRoute /> : <PrescheduledRoute />;
}
